import { render, staticRenderFns } from "./modal-ver_resumen.vue?vue&type=template&id=11735b62"
import script from "./modal-ver_resumen.vue?vue&type=script&lang=js"
export * from "./modal-ver_resumen.vue?vue&type=script&lang=js"
import style0 from "./modal-ver_resumen.vue?vue&type=style&index=0&id=11735b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports